import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AlertAttachment } from '../models/alert-attachment';

@Component({
  selector: 'nida-web-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class AlertBoxComponent {
  @Input() priority: number;
  @Input() showTrashCan: boolean;
  // TODO: Sanitise HTML Tags (Allow only strong, p, etc.)
  @Input() displayValue: string;
  @Input() footerText?: string;
  @Input() attachmentList?: Array<AlertAttachment>;

  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() attachmentClick: EventEmitter<AlertAttachment> = new EventEmitter();

  onDeleteClick() {
    this.deleteClick.emit();
  }

  onAttachmentClick(attach: AlertAttachment) {
    this.attachmentClick.emit(attach);
  }
}
